import React, { useEffect, useState } from "react";
import { case_study_list } from "src/constants";
import Style from "styles/components/customers_voice.module.scss";
import classNames from 'classnames';
import TopCaseStudyCard from 'components/TopCaseStudyCard';
import { Link } from 'gatsby';
import prepareImage from 'src/images/prepare.png';
import useScrollAnimation from 'hooks/useScrollAnimation';

const fetchCaseStudyList = async () => {
  try {
    const response = await fetch(case_study_list, { cache: "no-store" });
    if (!response.ok) {
      throw new Error("事例データの取得に失敗しました");
    }
    return await response.json();
  } catch (error) {
    console.error("fetchCaseStudyList エラー:", error);
    return [];
  }
};

export const useCaseStudy = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const loadCaseStudy = async () => {
      const json = await fetchCaseStudyList();
      if (!json) return setItems([]);
      setItems(json.slice(0, 3));
    };

    loadCaseStudy().catch(error => {
      console.error("事例のロード中にエラーが発生しました:", error);
      setItems([]);
    });
  }, []);

  return items;
};


const CaseStudyPresenter = ({ caseStudyItems }) => {
  const isEmpty = caseStudyItems.length === 0;
  const [sectionRef, isVisible] = useScrollAnimation(0.15);

  return (
    <section ref={sectionRef} className={classNames(Style.customersVoice, { [Style.customersVoice__visible]: isVisible })}>
      <h2 className={classNames(Style.customersVoice__title)}>
          お客様の声
      </h2>
      {isEmpty ? (
        <div className={Style.customersVoice__empty}>
          <img src={prepareImage} alt="準備中" />
        </div>
      ) : (
        <>
          <div className={classNames(Style.customersVoice__gridContainer)}>
            {caseStudyItems.map((caseStudy, idx) => (
              <TopCaseStudyCard
                key={idx}
                id={caseStudy.id}
                storeName={caseStudy.storeName}
                customerName={caseStudy.customerName}
                storeLogo={caseStudy.storeLogo}
                thmImageSrc={caseStudy.thumbnailImage}
                content={caseStudy.content}
              />
            ))}
          </div>
          {/* TODO: 事例が追加されたら表示する
          <Link className={Style.customersVoice__button} to='/case_study'>
            ＞事例一覧はこちら
          </Link>
          */}
        </>
      )}
    </section>
  );
};


const CaseStudyGrid = () => {
  const items = useCaseStudy();
  return <CaseStudyPresenter caseStudyItems={items} />;
};

export default CaseStudyGrid;
